import React from 'react';
import { motion } from 'framer-motion';
import { Clock, Zap } from 'lucide-react';
import { SHOP_CONTENT } from '../../utils/constants';
import { fadeInUp, staggerContainer, staggerItem } from '../../utils/animations';

const ShopSection = () => {
  return (
    <section className="py-24 bg-gradient-to-br from-neutral-900 via-neutral-800 to-neutral-900 text-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: '-100px' }}
        >
          <motion.div
            className="inline-flex items-center space-x-2 bg-brand-500/20 border border-brand-500/30 rounded-full px-4 py-2 mb-6"
            variants={fadeInUp}
          >
            <Clock size={16} className="text-brand-400" />
            <span className="text-brand-300 text-sm font-medium" style={{ fontFamily: "'Livvic', sans-serif" }}>Coming Soon</span>
          </motion.div>

          <motion.h2
            className="text-3xl sm:text-4xl mb-6 leading-tight"
            style={{ fontFamily: "'Livvic', sans-serif", fontWeight: 700 }}
            variants={fadeInUp}
          >
            {SHOP_CONTENT.heading}
          </motion.h2>

          <motion.p
            className="text-neutral-300 text-lg leading-relaxed mb-12 max-w-2xl mx-auto"
            style={{ fontFamily: "'Livvic', sans-serif" }}
            variants={fadeInUp}
          >
            {SHOP_CONTENT.text}
          </motion.p>
        </motion.div>

        <motion.p
          className="text-white/60 text-sm font-semibold uppercase tracking-wider mb-6"
          style={{ fontFamily: "'Livvic', sans-serif" }}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={fadeInUp}
        >
          Features launching soon:
        </motion.p>

        <motion.div
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-12 max-w-3xl mx-auto"
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: '-100px' }}
        >
          {SHOP_CONTENT.features.map((feature, i) => (
            <motion.div
              key={i}
              className="flex items-center space-x-3 bg-white/5 border border-white/10 rounded-xl px-5 py-4"
              variants={staggerItem}
            >
              <Zap size={16} className="text-accent-teal flex-shrink-0" />
              <span className="text-white/80 text-sm font-medium" style={{ fontFamily: "'Livvic', sans-serif" }}>{feature}</span>
            </motion.div>
          ))}
        </motion.div>

        <motion.button
          className="bg-brand-500 text-white px-8 py-3 rounded-lg font-medium hover:bg-brand-600 transition-colors shadow-lg shadow-brand-500/25"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={fadeInUp}
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
        >
          {SHOP_CONTENT.buttonText}
        </motion.button>
      </div>
    </section>
  );
};

export default ShopSection;